import { Localized, useLocalization } from '@fluent/react';
import { useField } from 'formik';

import { InputFormik } from '#/components/controls/Input';
import { CustomerComboboxFormik } from '../controls/CustomerCombobox';
import { LogisticsComboboxFormik } from '../controls/LogisticsCombobox';
import { UserTypeComboboxFormik } from '../controls/UserTypeCombobox';
import { MANAGE_CUSTOMER, MANAGE_LOGISTIC } from '#/constants/manage-user-type-list';

const AddUserForm: React.FC<AddUserFormProps> = ({ readOnly }) => {
  const { l10n } = useLocalization();
  const [userCode] = useField('manageUserCode');

  return (
    <div className={'space-y-6'}>
      <Localized id="email" attrs={{ placeholder: true }}>
        <InputFormik label={l10n.getString('email')} name="email" readOnly={readOnly} type="text" />
      </Localized>

      <Localized id="username" attrs={{ placeholder: true }}>
        <InputFormik
          label={l10n.getString('username')}
          name="username"
          readOnly={readOnly}
          type="text"
        />
      </Localized>

      {!readOnly && (
        <Localized id="password" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('password')} name="password" type="password" />
        </Localized>
      )}

      <Localized id="manage-user-type" attrs={{ placeholder: true }}>
        <UserTypeComboboxFormik
          disabled={readOnly}
          label={l10n.getString('manage-user-type')}
          name={'manageUserCode'}
        />
      </Localized>

      {userCode.value === MANAGE_LOGISTIC.code && (
        <Localized id="manage-logistic" attrs={{ placeholder: true }}>
          <LogisticsComboboxFormik
            disabled={readOnly}
            label={l10n.getString('manage-logistic')}
            name={'logisticsId'}
          />
        </Localized>
      )}

      {userCode.value === MANAGE_CUSTOMER.code && (
        <Localized id="manage-customer" attrs={{ placeholder: true }}>
          <CustomerComboboxFormik
            disabled={readOnly}
            label={l10n.getString('manage-customer')}
            name={'customerId'}
          />
        </Localized>
      )}
    </div>
  );
};

export type AddUserFormProps = { readOnly: boolean };

export default AddUserForm;
